import {ZoomSpec} from './map.types';
import {PointExpression} from 'leaflet';

export const MAP_TILE_CONFIG = {
  url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
  options: {
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
    maxNativeZoom: 16,
    maxZoom: 19
  }
};

export const MapMarkerSize = {
  LARGE: [96, 96] as PointExpression,
  MEDIUM: [64, 64] as PointExpression,
  SMALL: [32, 32] as PointExpression
};

export const DEFAULT_ZOOM_SPEC: ZoomSpec = {
  zoomLevel: 13,
  minZoom: 3,
  maxZoom: 19,
  zoomControl: false,
  zoomControlPosition: "topright"
};
